var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFileGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0277C6",
    points: "44,27 4,27 1,23 5,19 43,19 47,23 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M31,1v10c0,1.105,0.895,2,2,2h10L31,1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008CFF",
    d: "M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.051,31.402h3.389v4.232c-0.92,0.315-1.932,0.473-3.035,0.473c-1.21,0-2.146-0.351-2.806-1.053 c-0.661-0.702-0.991-1.703-0.991-3.002c0-1.268,0.361-2.255,1.085-2.96s1.737-1.058,3.04-1.058c0.494,0,0.961,0.046,1.399,0.139 c0.438,0.094,0.821,0.212,1.146,0.355l-0.671,1.664c-0.566-0.279-1.188-0.418-1.864-0.418c-0.62,0-1.099,0.201-1.437,0.604 c-0.339,0.403-0.508,0.979-0.508,1.727c0,0.734,0.153,1.294,0.459,1.679c0.307,0.385,0.748,0.577,1.324,0.577 c0.314,0,0.605-0.03,0.87-0.091v-1.229h-1.401V31.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.04,36v-7.853h2.132V36H24.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.959,36h-2.09v-7.853h4.641v1.702h-2.551v1.499h2.353v1.702h-2.353V36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileGif);
export default __webpack_public_path__ + "static/media/icon-file-gif.0a43574a67b65a0a77141edcb35d2837.svg";
export { ForwardRef as ReactComponent };